import React from "react";
import DataTable from "react-data-table-component";
import { useState, useMemo } from "react";
import UserFilter from "./users/UserFilter";
import { useEffect } from "react";
import authStorage from "../service/authStorage";
import { useNavigate } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import ModalWindowChangeUserPassword from "./usersModalWindows/ModalWindowChangeUserPassword";
import ModalWindowAddNewUser from "./usersModalWindows/ModalWindowAddNewUser";
import ModalWindowDeleteUser from "./usersModalWindows/ModalWindowDeleteUser";

const UsersDataTable = (props) => {
  const BEARER = authStorage();
  const USERS_URL = process.env.REACT_APP_ARI_URL + "/users/";
  const PASS_URL_POSTFIX = "/password";

  const [filterText, setFilterText] = useState("");
  const navigate = useNavigate();

  const [userId, setUserId] = useState();
  const [username, setUsername] = useState("");
  const [firstPass, setFirstPass] = useState("");
  const [secondPass, setSecondPass] = useState("");
  const [isPassEquals, setIsPassEquals] = useState(false);
  const [isSuccessChangePassword, setIsSuccessChangePassword] = useState(false);

  const [userIdForDelete, setIdForDeleteUser] = useState();
  const [usernameForDelete, setUsernameForDelete] = useState();

  const [newUserUsername, setNewUserUsername] = useState();
  const [newUserPassword, setNewUserPassword] = useState();
  const [newUserRole, setNewUserRole] = useState("CLIENT");

  const [isValidUsername, setIsValidUsername] = useState();
  const [isValidPassword, setIsValidPassword] = useState();

  const [errorMsg, setErrorMsg] = useState();
  const [errUsernameMsg, setErrUsernameMsg] = useState();
  const [errPassMsg, setErrPassMsg] = useState();

  const [isNeedChangePasswordRequest, setIsNeedChangePasswordRequest] =
    useState(false);
  const [isNeedAddNewUserRequest, setIsNeedAddNewUserRequest] = useState();
  const [isNeedDeleteUserRequest, setIsNeedDeleteUserRequest] = useState();

  const [isShowAddNewUserButton, setIsShowAddNewUserButton] = useState();
  const [isShowChangePasswordWindow, setIsShowChangePasswordWindow] =
    useState(false);
  const [isShowAddNewUserWindow, setIsShowAddNewUserWindow] = useState();
  const [isShowDeleteUserWindow, setIsShowDeleteUserWindow] = useState();

  const [isFirstLoadingChangePassword, setIsFirstLoadingChangePassword] =
    useState(true);
  const [isFirstLoadingAddUser, setIsFirstLoadingAddUser] = useState(true);
  const [isFirstLoadingDeleteUser, setIsFirstLoadingDeleteUser] =
    useState(true);

  // USERS TABLE  BLOCK-------------------------------
  // filter table
  const filteredItems = props.items.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );

  // update table items
  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setFilterText("");
      }
    };

    return (
      <UserFilter
        filterText={filterText}
        handleFilter={(e) => setFilterText(e.target.value)}
        handleClear={handleClear}
      />
    );
  }, [filterText]);

  // pars table
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      grow: 0,
    },
    {
      name: "USERNAME",
      selector: (row) => row.username,
      sortable: true,
      grow: 5,
    },
    {
      name: "ROLE",
      selector: (row) => row.role,
      sortable: true,
      right: true,
      grow: 1,
    },
    {
      name: "RESET PASSWORD",
      grow: 1,
      cell: (row) => (
        <div>
          <div className="openbtn text-center">
            <button
              type="button"
              onClick={(e) =>
                handleShowChangePasswordUserWindow(e, row.username, row.id)
              }
              className="large-button green"
            >
              RESET PASSWORD
            </button>
          </div>
          <div>
            <ModalWindowChangeUserPassword
              errorMsg={errorMsg}
              isShowWindow={isShowChangePasswordWindow}
              onHide={(e) => handleChangeUserPasswordCloseWindow(e)}
              handleFirstPass={(e) => handleFirstPass(e)}
              handleSecondPass={(e) => handleSecondPass(e)}
              isPassEquals={isPassEquals}
              handleSubmit={(e) => handleSubmit(e, row.id)}
              username={username}
            />
          </div>
        </div>
      ),
    },
    {
      name: "DELETE",
      grow: 1,
      cell: (row) => (
        <div>
          <div className="openbtn text-center">
            <button
              type="button"
              onClick={(e) =>
                handleShowDeleteUserWindow(e, row.username, row.id)
              }
              className="large-button red"
            >
              DELETE
            </button>
          </div>
          <div>
            <ModalWindowDeleteUser
              errorMsg={errorMsg}
              username={usernameForDelete}
              isShowWindow={isShowDeleteUserWindow}
              onHide={(e) => handleDeleteUserCloseWindow(e)}
              handleSubmit={(e) => handleDeleteUserSubmit(e, row.id)}
            />
          </div>
        </div>
      ),
    },
  ];

  // CHANGE USER PASSWORD BLOCK-------------------------------
  // update pass matching
  useEffect(() => {
    matchPass();
  }, [firstPass, secondPass]);

  // CHANGE PASSWORD request
  useEffect(() => {
    if (isFirstLoadingChangePassword) {
      setIsFirstLoadingChangePassword(false);
      return;
    }
    const dto = {
      password: firstPass,
    };

    const setNewPass = async () => {
      setErrorMsg();
      try {
        const response = await fetch(USERS_URL + userId + PASS_URL_POSTFIX, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: BEARER,
          },
          body: JSON.stringify(dto),
        });
        if (response.status === 401) {
          navigate("/login");
        }
        if (response.status === 400) {
          const items = await response.json();
          setErrorMsg(items.error);
        } else {
          setIsShowChangePasswordWindow(false);
          setIsSuccessChangePassword(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    setIsNeedChangePasswordRequest(false);
    if (isSuccessChangePassword) {
      createNotification();
      setIsSuccessChangePassword(false);
    }
    setErrorMsg();
    setNewPass();
    setUserId();
    setUsername();
  }, [isNeedChangePasswordRequest]);

  // CHANGE PASSWORD handle
  const handleSubmit = (event, id) => {
    event.preventDefault();
    setIsNeedChangePasswordRequest(true);
  };

  // PASSWORD handle
  const handleFirstPass = (event) => {
    setFirstPass(event.target.value);
    event.preventDefault();
  };

  // PASSWORD handle
  const handleSecondPass = (event) => {
    setSecondPass(event.target.value);
    event.preventDefault();
  };

  // matching PASSWORDS
  const matchPass = () => {
    if (
      firstPass.length >= 3 &&
      secondPass.length >= 3 &&
      firstPass === secondPass
    ) {
      setIsPassEquals(true);
    } else {
      setIsPassEquals(false);
    }
  };

  // CHANGE PASSWORD Window handle
  const handleShowChangePasswordUserWindow = (event, user, id) => {
    event.preventDefault();
    setUserId(id);
    setUsername(user);
    setFirstPass("");
    setSecondPass("");
    setErrorMsg();
    setIsShowChangePasswordWindow(true);
  };

  // CHANGE PASSWORD Window close handle
  const handleChangeUserPasswordCloseWindow = (event) => {
    event.preventDefault();
    setIsShowChangePasswordWindow(false);
    setUserId();
    setUsername();
  };

  // notification CHANGE PASSWORD
  const createNotification = () => {
    return NotificationManager.success(
      "Password for " + `${username}` + " has been successfully changed"
    );
  };

  // AGG NEW USER BLOCK-------------------------------
  // show window ADD NEW USER
  const handleAddNewUserWindowOpen = (event) => {
    event.preventDefault();
    setIsShowAddNewUserWindow(true);
  };

  // handle ADD NEW USER Window
  const handleAddNewUserSubmit = (event) => {
    event.preventDefault();
    setIsNeedAddNewUserRequest(true);
    // setIsNeedAddNewUserRequest(false);
  };

  // handle and validate NEW USER USERNAME
  const handleNewUserUsername = (event) => {
    event.preventDefault();
    setErrUsernameMsg();
    const username = event.target.value;
    setNewUserUsername(username);
    if (isValidateCredentials(username)) {
      setIsValidUsername(true);
      setErrorMsg();
    } else {
      setIsValidUsername(false);
      setErrUsernameMsg("Username must be 3 or more characters");
    }
  };

  // handle and validate NEW USER PASSWORD
  const handleNewUserPassword = (event) => {
    event.preventDefault();
    setErrPassMsg();
    const password = event.target.value;
    setNewUserPassword(password);
    if (isValidateCredentials(password)) {
      setIsValidPassword(true);
    } else {
      setIsValidPassword(false);
      setErrPassMsg("Password must be 3 or more characters");
    }
  };

  // handle NEW USER ROLE
  const handleNewUserRole = (event) => {
    event.preventDefault();
    setNewUserRole(event.target.value);
  };

  // validation
  const isValidateCredentials = (value) => {
    return value.length >= 3;
  };

  // handle ADD NEW USER window close
  const handleAddNewUserWindowClose = (event) => {
    event.preventDefault();
    setIsShowAddNewUserWindow(false);
    setNewUserUsername();
    setNewUserPassword();
    setErrorMsg();
  };

  // update flag show ADD NEW USER button
  useEffect(() => {
    if (isValidUsername && isValidPassword) {
      setIsShowAddNewUserButton(true);
    } else {
      setIsShowAddNewUserButton(false);
    }
  }, [isValidPassword, isValidPassword]);

  // ADD NEW USER request
  useEffect(() => {
    if (isFirstLoadingAddUser) {
      setIsFirstLoadingAddUser(false);
      return;
    }
    const dto = {
      username: newUserUsername,
      password: newUserPassword,
      role: newUserRole,
    };

    const addNewUser = async () => {
      setErrorMsg();
      try {
        const response = await fetch(USERS_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: BEARER,
          },
          body: JSON.stringify(dto),
        });
        if (response.status === 401) {
          navigate("/login");
        }
        if (response.status === 400) {
          const items = await response.json();
          setErrorMsg(items.error);
          setIsNeedAddNewUserRequest(false);
          return;
        } else {
          setNewUserUsername();
          setNewUserRole("CLIENT");
          setNewUserPassword();

          setErrorMsg();
          setErrUsernameMsg();
          setErrPassMsg();

          setIsShowAddNewUserWindow(false);
          props.setIsNeedRefreshUsers(true);
          setIsNeedAddNewUserRequest(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    addNewUser();
  }, [isNeedAddNewUserRequest]);

  // DELETE USER BLOCK-------------------------------
  // handle DELETE USER window open
  const handleShowDeleteUserWindow = (event, username, id) => {
    event.preventDefault();
    setIdForDeleteUser(id);
    setUsernameForDelete(username);
    setIsShowDeleteUserWindow(true);
  };

  // handle DELETE USER window close
  const handleDeleteUserCloseWindow = (event) => {
    event.preventDefault();
    setIsShowDeleteUserWindow(false);
    setIdForDeleteUser();
    setUsernameForDelete();
  };

  // handle DELETE USER
  const handleDeleteUserSubmit = (event) => {
    event.preventDefault();
    // setIdForDeleteUser(id);
    setIsNeedDeleteUserRequest(true);
  };

  // DELETE USER request
  useEffect(() => {
    if (isFirstLoadingDeleteUser) {
      setIsFirstLoadingDeleteUser(false);
      return;
    }

    const deleteUser = async () => {
      setErrorMsg();
      try {
        const response = await fetch(USERS_URL + userIdForDelete, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: BEARER,
          },
        });
        if (response.status === 401) {
          navigate("/login");
        }
        if (response.status === 400) {
          const items = await response.json();
          setErrorMsg(items.error);
          setIsNeedDeleteUserRequest(false);
          return;
        } else {
          setIdForDeleteUser();
          setErrorMsg();

          setIsShowDeleteUserWindow(false);
          props.setIsNeedRefreshUsers(true);
          setIsNeedDeleteUserRequest(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    deleteUser();
    setIdForDeleteUser();
  }, [isNeedDeleteUserRequest]);

  return (
    <div>
      <div>
        <NotificationContainer />
      </div>
      <div>
        <DataTable
          columns={columns}
          data={filteredItems}
          defaultSortFieldID={1}
          subHeader
          subHeaderComponent={subHeaderComponent}
        />
      </div>
      <div className="d-flex flex-row-reverse">
        <button
          className="large-button deep-blue"
          onClick={(e) => handleAddNewUserWindowOpen(e)}
        >
          ADD NEW USER
        </button>
      </div>
      <div>
        <ModalWindowAddNewUser
          errUsernameMsg={errUsernameMsg}
          errPassMsg={errPassMsg}
          errorMsg={errorMsg}
          onHide={(e) => handleAddNewUserWindowClose(e)}
          handleAddNewUserSubmit={(e) => handleAddNewUserSubmit(e)}
          isShowWindow={isShowAddNewUserWindow}
          handleNewUserUsername={(e) => handleNewUserUsername(e)}
          handleNewUserPassword={(e) => handleNewUserPassword(e)}
          handleNewUserRole={handleNewUserRole}
          newUserRole={newUserRole}
          isShowAddNewUserButton={isShowAddNewUserButton}
        />
      </div>
    </div>
  );
};

export default UsersDataTable;
